import Box from "./Box"
import styled from "./styled"
import { motion } from "framer-motion"

const AnimatedBox = styled(motion.custom(Box))``

export default AnimatedBox
